import { Table } from "../../../../../../components/Functional";
import SectionHeader from "../../components/SectionHeader";
import { FETCH_CONSIGNMENT_DOCUMENTS } from "../../../../../../graphql/query/ConsignmentDocument";
import { Button, Modal } from "../../../../../../components/ui";
import AddDocuments from "../Documents/components/AddDocuments";
import Actions from "../Documents/components/Actions";
import useUser from "../../../../../../hooks/useUser";

const Condition = props => {
  const { consignment } = props || {};
  const { hasPermission } = useUser();

  const tableProps = {
    variant: "dynamicHeight",
    dataKey: "consignmentDocuments",
    headers: [
      { label: "File Name", name: "fileName", type: "label" },
      { label: "File Type", name: "fileType", type: "label" },
      { label: "Date", name: "updatedAt", type: "date" },
      { label: "", name: "action", type: "custom", component: Actions },
    ],
    inputs: [{ label: "Name", name: "name", type: "text", view: "partial" }],
    FETCH_QUERY: FETCH_CONSIGNMENT_DOCUMENTS,
    variables: {
      consignmentId: +consignment?.id,
      type: "conditionReports",
    },
  };

  const modalProps = {
    body: AddDocuments,
    closeOnBackdrop: true,
    consignment,
    hideCloseButton: true,
    scale: "md",
    type: "conditionReports",
    disabled: !hasPermission("UPDATE_CONSIGNMENT"),
  };

  const actions = [
    {
      component: () => {
        return (
          <Modal {...modalProps}>
            <Button
              label="Upload"
              action="black"
              disabled={!hasPermission("UPDATE_CONSIGNMENT")}
            />
          </Modal>
        );
      },
    },
  ];

  return (
    <div className="w-full">
      <SectionHeader title="Condition" actions={actions} />
      <div className="mb-6 w-full">
        <Table {...tableProps} />
      </div>
    </div>
  );
};

export default Condition;
